import { render, staticRenderFns } from "./binding-card.vue?vue&type=template&id=b8623866&scoped=true"
import script from "./binding-card.vue?vue&type=script&lang=js"
export * from "./binding-card.vue?vue&type=script&lang=js"
import style0 from "./binding-card.vue?vue&type=style&index=0&id=b8623866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8623866",
  null
  
)

export default component.exports